<p class="modal-title">Admin: Add Filter</p>
<div class="body flex flex-col">
  <form [formGroup]="limitForm" (ngSubmit)="onSubmit()" #limitFormRef="ngForm">
    <app-form-field
      [label]="'Skin Name'"
      [formControl]="skinName"
      [errorType]="'outline'"
      [id]="'time'"
      [submitting]="false"
      [disabled]="true"
      [placeholder]="'Enter Skin Name...'"
      [error]="
        !skinName.valid && limitFormRef['submitted'] ? 'Field is required' : ''
      "
    />
    <app-form-field
      [label]="'Limit'"
      [formControl]="limitValue"
      [errorType]="'outline'"
      [id]="'reason'"
      [submitting]="false"
      [placeholder]="'Enter Limit...'"
      [error]="
        !limitValue.valid && limitFormRef['submitted']
          ? 'Field is required'
          : ''
      "
    />
    <button class="button button--style-yellow h-32 padding-x-12" type="submit">
      Save
    </button>
  </form>
</div>
